import { useState, Dispatch, SetStateAction, Ref, useImperativeHandle } from 'react';
import { FilterState } from '../FiltersArea';
import OptionsRangeFilter from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';
import { Resettable } from '@/models/Resettable';
import { TransactionStatus } from '../futureTransactions';

interface TransactionStatusOption {
  id: TransactionStatus;
  label: string;
  checked: boolean;
}

interface TransactionStatusFilterProps {
  setFilterState: Dispatch<SetStateAction<FilterState>>;
  ref?: Ref<Resettable>;
}

/**
 * HAT-1203: has the money moved yet? The same words the export's status column uses.
 * «עתידיות» takes every future row, projected ones included.
 */
const TransactionStatusFilter = ({ setFilterState, ref }: TransactionStatusFilterProps) => {
  const [options, setOptions] = useState<TransactionStatusOption[]>([
    { id: 'current', label: 'transactionStatusFilterCurrent', checked: false },
    { id: 'future', label: 'transactionStatusFilterFuture', checked: false },
  ]);

  const apply = (updatedOptions: TransactionStatusOption[]) => {
    setOptions(updatedOptions);
    setFilterState((prev) => ({ ...prev, statuses: updatedOptions.filter((option) => option.checked).map((option) => option.id) }));
  };

  useImperativeHandle(ref, () => ({
    reset: () => setOptions((prev) => prev.map((option) => ({ ...option, checked: false }))),
  }));

  return (
    <OptionsRangeFilter
      title="transactionStatusColumn"
      filterType="options"
      options={options.map(({ id, label, checked }) => ({ id, label, checked }))}
      onOptionChange={(optionId) => apply(options.map((option) => (option.id === optionId ? { ...option, checked: !option.checked } : option)))}
      onSelectAllChange={(selectAll) => apply(options.map((option) => ({ ...option, checked: selectAll })))}
      selectionType="checkbox"
    />
  );
};

export default TransactionStatusFilter;
